import { Component, AfterViewInit } from '@angular/core';
import { AuthenticationService } from '@app/auth/services/authentication.service';

@Component({
  selector: 'app-list-time',
  templateUrl: './list-time.component.html',
  styleUrls: ['./list-time.component.scss']
})
export class ListTimeComponent implements AfterViewInit {
  isUpdateOperation = false;
  constructor(public authService: AuthenticationService) { }

  ngAfterViewInit() {}

}
